import { render } from "./Bookmarks.vue?vue&type=template&id=36fc09e1&scoped=true"
import script from "./Bookmarks.vue?vue&type=script&lang=js"
export * from "./Bookmarks.vue?vue&type=script&lang=js"

import "./Bookmarks.vue?vue&type=style&index=0&id=36fc09e1&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fc09e1"]])

export default __exports__